import { compose, withHandlers } from 'recompose';

import DisconnectMailchimp from './DisconnectMailchimp';
import { disconnectFromMailchimp } from '../../actions';
import withToggle from '../../../../../../common/hoc/withToggle';
import { Logger } from '../../../../../../../modules/infra/observability/logger';
import withMailchimpSettings from '../../withMailchimpSettings';

export default compose(
  withToggle('opened', false),
  withToggle('loading', false),
  withMailchimpSettings,
  withHandlers({
    handleDisconnect: ({ brandId, fetchSettings, loadingOn, loadingOff, openedOff }) => async () => {
      loadingOn();

      try {
        await disconnectFromMailchimp(brandId);
      } catch (error) {
        Logger.error('Disconnect mailchimp', {
          error,
          action: 'Disconnect mailchimp',
        });
      } finally {
        await fetchSettings(brandId);
        loadingOff();
        openedOff();
      }
    },
  })
)(DisconnectMailchimp);
